import { useTranslation } from 'react-i18next';

import defaultStyles from '../../../../styles/formSetStyles.module.css';
import styles from './index.module.css';

import { Button, Width } from '../../../../components/Button';

interface Props {
  onPaymentChoice: (value: boolean) => void;
  labelOverride?: string | null;
}

export function FormOfPayment({ onPaymentChoice, labelOverride }: Props) {
  const { t } = useTranslation();
  const label = t(`Will you be using insurance to pay for today's visit?`);
  return (
    <div className={styles.FormOfPaymentContainer}>
      <div className={defaultStyles.Label}>{labelOverride || label}</div>
      <div className={defaultStyles.ButtonSubmitWrapper}>
        <Button
          type="button"
          className={styles.PaymentChoiceButton}
          onClick={() => onPaymentChoice(true)}
          width={Width.ContentWidth}
          children={t('Yes')}
        />
        <Button
          type="button"
          className={styles.PaymentChoiceButton}
          onClick={() => onPaymentChoice(false)}
          width={Width.ContentWidth}
          children={t('No')}
        />
      </div>
    </div>
  );
}
